import axios from '@/libs/axios'

// 账号密码登录流程
export const accountPasswordLogin = params => {
  return axios.request({
    url: `/v1/login`,
    method: 'POST',
    params
  })
}

// 导购机登录流程
export const guideLogin = params => {
  return axios.request({
    url: `/v1/login/scan`,
    method: 'GET',
    params
  })
}

// 获取登录的用户信息
export const getUserInfo = params => {
  return axios.request({
    url: `/v1/user/current`,
    method: 'GET',
    params
  })
}

// 获取店铺信息
export const getShopInfo = () => {
  return axios.request({
    url: `/v1/user/current/shopinfo`,
    method: 'GET'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js